'use strict';

/**
 * Faq блок с аккордеоном
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

function faqAccordion ($container = $('body')) {
	$container.find('[data-faq-accordion]').each(function () {
		let item = $('.faq-accordion__title'),
			answer = $('.faq-accordion__text')

		item.on('click', function () {
			let thisQuestion = $(this);

			function toggle() {
				thisQuestion.next().stop().slideToggle(300);
			}

			if (thisQuestion.next().is(':visible')) {
				toggle();
				thisQuestion.removeClass('is-open')
			} else {
				answer.filter(":visible").slideToggle(300);
				toggle();
				thisQuestion.addClass('is-open')
			}
		})
	});
}

export default faqAccordion;



// WEBPACK FOOTER //
// ./src/js/_modules/faqAccordion.js